/**
 * @generated SignedSource<<69fca911676c6f26cf1622f2ffe8c5e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UrlMappingCacheStatus_user$data = {
  readonly urlMappingCache: {
    readonly present: boolean;
    readonly expiresAt: string | null;
    readonly remainingSeconds: number | null;
    readonly ttlSeconds: number;
  };
  readonly " $fragmentType": "UrlMappingCacheStatus_user";
};
export type UrlMappingCacheStatus_user = UrlMappingCacheStatus_user$data;
export type UrlMappingCacheStatus_user$key = {
  readonly " $data"?: UrlMappingCacheStatus_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UrlMappingCacheStatus_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UrlMappingCacheStatus_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UrlMappingCacheStatus",
      "kind": "LinkedField",
      "name": "urlMappingCache",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "present",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expiresAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ttlSeconds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1337a50fda0fd66468e306b557c5b352";

export default node;
